<!-- 提成明细 -->
<template>
  <div class="main">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="projectName" suffix-icon="el-icon-search" placeholder="搜索项目名称" clearable
        @change="onSearch"></el-input>
      <el-input class="s_input" v-model="orderNum" suffix-icon="el-icon-search" placeholder="搜索订单编号" clearable
        @change="onSearch"></el-input>
      <el-input class="s_input" v-model="employeeName" suffix-icon="el-icon-search" placeholder="搜索员工名称" clearable
        @change="onSearch"></el-input>
      <el-date-picker v-model="dateTime" type="daterange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" clearable @change="handleSelectData" value-format="yyyy-MM-dd"></el-date-picker>
    </div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="projectName" label="项目名称"></el-table-column>
        <el-table-column min-width="110" show-overflow-tooltip prop="projectType" label="项目类型">
          <template slot-scope="scope">
            <span v-if="scope.row.projectType == 1">正式项目</span>
            <span v-if="scope.row.projectType == 2">体验项目</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="orderCode" label="订单编号"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="employeeName" label="员工名称"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="payAmount" label="核销金额（元）"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="commissionAmount"
          label="提成金额(元)"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="commissionRate" label="提成比例(%)"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="createdTime" label="订单时间"></el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projectName: "", // 项目名称
      orderNum: "", // 订单编号
      employeeName: "", // 员工名称
      store: "", // 门店
      dateTime: [], // 时间区间
      tableData: [], // 表格数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getProjectConsumeList()
  },

  methods: {
    // 获取列表
    getProjectConsumeList() {
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        projectName: this.projectName || null,
        orderCode: this.orderNum || null,
        employeeName: this.employeeName || null,
        storeId: this.$store.state.userInfo.bizId,
      }
      // 时间区间
      if (this.dateTime && this.dateTime.length === 2) {
        params.startTime = this.dateTime[0]
        params.endTime = this.dateTime[1]
      } else {
        params.startTime = null
        params.endTime = null
      }
      this.$axios
        .get(this.$api.getProjectConsumeList, { params })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
        })
        .catch(err => {
          this.$message({
            message: err.desc,
            type: "error",
          })
        })
    },
    onSearch() {
      this.clearData()
      this.getProjectConsumeList()
    },
    // 时间搜索
    handleSelectData(value) {
      this.dateTime = value
      this.onSearch()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getProjectConsumeList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getProjectConsumeList()
    },
  },
}
</script>

<style scoped lang="scss">
.main {}
</style>
